import { useState } from "react";
import styles from "../styles/Navbar.module.css";

function Navbar() {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => {
    setOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setOpen(false);
  };

  return (
    <div className={styles.navbar}>
      {/* HAMBURGER */}
      <button className={styles.burger} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* OVERLAY */}
      <div
        className={`${styles.overlay} ${open ? styles.showOverlay : ""}`}
        onClick={closeMenu}
      ></div>

      {/* SIDE MENU */}
      <div className={`${styles.menu} ${open ? styles.showMenu : ""}`}>
        <h2 className={styles.logo}>
          Kitchen<span>Bar</span>
        </h2>

        <a href="#home" onClick={closeMenu}>Home</a>
        <a href="#about" onClick={closeMenu}>About</a>
        <a href="#menu" onClick={closeMenu}>Menu</a>
        <a href="#gallery" onClick={closeMenu}>Gallery</a>
        <a href="#events" onClick={closeMenu}>Events</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>

        <a href="#contact" className={styles.reserve} onClick={closeMenu}>
          Reserve Table
        </a>
      </div>
    </div>
  );
}

export default Navbar;